<template>
    <div class="users-admin-page">
        <div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="title-button">
                            <h2>Dashboard</h2>
                        </div>
                    </div>
                </div>

                <div class="panel-table-admin radius-6">
                    <div class="row head">
                        <div class="col-md-6">
                            <h6>Usuários da plataforma</h6>
                            <div class="font-14">Subtitulo aqui</div>
                        </div>

                        <div class="col-md-6 text-right buttons">
                            <b-button
                                variant="dark"
                                size="sm"
                                class="icon-button display-inline-flex"
                                v-print="'#panel-table-admin-table'"
                            >
                                <b-icon icon="download" aria-hidden="true"></b-icon>
                                Exportar
                            </b-button>

                            <b-button
                                variant="primary"
                                size="sm"
                                v-b-toggle.sidebar-add-user
                                @click="openSidebarAddUser()"
                                v-if="getUserStatusProfile === 2"
                            >
                                Adicionar usuário
                            </b-button>
                        </div>
                    </div>

                    <div class="filters display-flex">
                        <div class="filter-field">
                            <label for="search-field">Pesquisar</label>

                            <b-input-group class="search-field right-space">
                                <b-input-group-prepend>
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input placeholder="Pesquisar" v-model="searchFieldText"></b-form-input>
                            </b-input-group>
                        </div>

                        <b-form-group label="Perfil" label-for="profile" class="filter-field">
                            <b-form-select
                                id="profile"
                                name="profile"
                                v-model="profile.selected"
                                :options="profile.options"
                            ></b-form-select>
                        </b-form-group>

                        <b-form-group label="Status" label-for="status" class="filter-field">
                            <b-form-select
                                id="status"
                                name="status"
                                v-model="status.selected"
                                :options="status.options"
                            ></b-form-select>
                        </b-form-group>
                    </div>

                    <b-table
                        id="panel-table-admin-table"
                        :items="getTableData"
                        :fields="getMessageFields"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :busy="false"
                        responsive
                        hover
                    >
                        <template #cell(id_permissao)="data">
                            <div class="profile" :class="profileOptions[data.item.id_permissao].key">
                                {{ profileOptions[data.item.id_permissao].value }}
                            </div>
                        </template>

                        <template #cell(id_status)="data">
                            <span class="status" :class="statusOptions[data.item.id_status].key">
                                {{ statusOptions[data.item.id_status].value }}
                            </span>
                        </template>

                        <template #cell(actions)="data">
                            <div class="actions display-flex items-center">
                                <div class="link" @click="openAlterProfileModal('alter-profile-modal-ref', data.item)">
                                    Trocar perfil
                                </div>

                                <div @click="openBlockModal(data.item)">
                                    <LockPP :statusLock="0" />
                                </div>

                                <div @click="openDeleteModal(data.item)">
                                    <i class="far fa-trash-alt"></i>
                                </div>
                            </div>
                        </template>
                    </b-table>

                    <div class="mt-3" v-if="getTableData.length > 0">
                        <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="rows"></b-pagination>
                    </div>
                </div>
            </div>
        </div>

        <b-sidebar id="sidebar-add-user" :title="'Adicionar usuário'" backdrop shadow right>
            <div>
                <b-form @submit.stop.prevent="addUserSubmit" novalidate>
                    <b-form-group label="Nome" label-for="name" class="required">
                        <b-form-input
                            id="name"
                            name="name"
                            v-model="$v.addUserForm.name.$model"
                            type="text"
                            placeholder="Digite nome"
                            :state="validateStateAddUser('name')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateAddUser('name')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="E-mail" label-for="email" class="required">
                        <b-form-input
                            id="email"
                            name="email"
                            v-model="$v.addUserForm.email.$model"
                            type="text"
                            placeholder="Digite e-mail"
                            :state="validateStateAddUser('email')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateAddUser('email')">
                            <div v-if="!$v.addUserForm.email.required">Campo obrigatório</div>
                            <div v-if="!$v.addUserForm.email.email">Escreva um e-mail válido</div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="CPF" label-for="cpf" class="required">
                        <b-form-input
                            id="cpf-user"
                            name="cpf"
                            v-model="$v.addUserForm.cpf.$model"
                            v-mask="'###.###.###-##'"
                            placeholder="Digite CPF"
                            :state="validateStateAddUser('cpf')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateAddUser('cpf')">
                            <div v-if="!$v.addUserForm.cpf.required">
                                Campo obrigatório
                            </div>

                            <div v-if="!$v.addUserForm.cpf.minLength">
                                Deve conter 14 caracteres
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Perfil" label-for="profile" class="required">
                        <b-form-select
                            id="profile"
                            name="profile"
                            v-model="$v.addUserForm.profile.selected.$model"
                            :options="addUserForm.profile.options"
                            :state="validateStateAddUser('profile')"
                        ></b-form-select>

                        <b-form-invalid-feedback :state="validateStateAddUser('profile')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="!getIsDarkTheme ? 'dark' : 'primary'" class="radius-6 submit">
                        Salvar
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-modal
            ref="alter-profile-modal-ref"
            title="Trocar perfil"
            size="lg"
            cancel-title="Cancelar"
            ok-title="Alterar"
            ok-variant="primary"
            @ok="alterProfile"
            :ok-disabled="!alterProfilerForm.profile.selected"
            :modal-class="`alter-profile-modal ${getIsDarkTheme ? 'dark-theme' : ''}`"
        >
            <div class="content">
                <b-form-group label="Perfil" label-for="profile">
                    <b-form-select
                        name="profile"
                        v-model="alterProfilerForm.profile.selected"
                        :options="alterProfilerForm.profile.options"
                    ></b-form-select>
                </b-form-group>
            </div>
        </b-modal>

        <b-modal
            ref="block-user-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="setBlockUser()">{{ btnMessage }}</b-button>
                <b-button variant="secondary" @click="hideModal('block-user-modal-ref')">Cancelar</b-button>
            </div>
        </b-modal>

        <b-modal
            ref="delete-user-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="danger" @click="deleteUser()">Sim, excluir</b-button>
                <b-button variant="secondary" @click="hideModal('delete-user-modal-ref')">Cancelar</b-button>
            </div>
        </b-modal>

        <b-modal
            ref="success-user-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="'Alteração realizada com sucesso'" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="hideModal('success-user-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import { PlatformApi } from '../../../../api/platform'
import { UsersAdminApi } from '../../../../api/admin/users-admin-api'
import { DashboardAdminApi } from '../../../../api/dashboard-admin-api'

const dashboardAdminApi = new DashboardAdminApi()

const usersAdminApi = new UsersAdminApi()

const platformApi = new PlatformApi()

export default {
    components: { LockPP, DangerModalPP, SuccessMsgModal, WarningMsgModal },
    data() {
        return {
            message: null,
            userSelected: null,
            btnMessage: null,
            userIdLogged: null,
            currentPage: 1,
            perPage: 6,
            searchFieldText: '',
            alterProfilerForm: {
                profile: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                }
            },
            addUserForm: {
                name: null,
                email: null,
                cpf: null,
                profile: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                }
            },
            profileOptions: {
                2: { key: 'admin', value: 'Admin' },
                3: { key: 'manager', value: 'Gestor' },
                4: { key: 'editor', value: 'Editor' }
            },
            statusOptions: {
                1: { key: 'active', value: 'Ativo' },
                2: { key: 'blocked', value: 'Bloqueado' }
            },
            profile: {
                selected: null,
                options: [{ value: null, text: 'Todos os perfis' }]
            },
            status: {
                selected: null,
                options: [
                    { value: null, text: 'Todos os status' },
                    { value: 1, text: 'Ativo' },
                    { value: 2, text: 'Bloqueado' }
                ]
            },
            messageFields: [
                {
                    key: 'name',
                    label: 'Nome'
                },
                {
                    key: 'cpf',
                    label: 'CPF'
                },
                {
                    key: 'email',
                    label: 'E-mail'
                },
                {
                    key: 'id_permissao',
                    label: 'Perfil'
                },
                {
                    key: 'id_status',
                    label: 'Status'
                }
            ],
            tableData: []
        }
    },
    validations: {
        addUserForm: {
            name: { required },
            email: { required, email },
            cpf: { required, minLength: minLength(14) },
            profile: {
                selected: { required }
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getTableData() {
            return this.tableData
                .map(item => ({
                    id: item.id,
                    name: item.name,
                    cpf: item.cpf,
                    email: item.email,
                    id_permissao: item.id_permissao,
                    id_status: item.id_status
                }))
                .filter(res => res.name.toLowerCase().includes(this.searchFieldText.toLowerCase()))
                .filter(res => this.profile.selected === null || this.profile.selected === res.id_permissao)
                .filter(res => this.status.selected === null || this.status.selected === res.id_status)
        },
        getProfile(index) {
            return index === null ? '' : index === 1 ? 'Admin' : index === 2 ? 'Editor' : 'Leitor'
        },
        rows() {
            return this.getTableData.length
        },
        getUserStatusProfile() {
            return this.$store.state.statusProfileUserAdm
        },
        getMessageFields() {
            const columns = this.messageFields

            if ([2].includes(this.getUserStatusProfile)) {
                columns.push({
                    key: 'actions',
                    label: 'Ações'
                })
            }

            return columns
        }
    },
    methods: {
        ...mapActions(['setIsLoading']),
        validateStateAddUser(nameField) {
            const { $dirty, $error } = this.$v.addUserForm[nameField]
            return $dirty ? !$error : null
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([
                    platformApi.getRegistrationPermissions(),
                    usersAdminApi.getUsers(),
                    dashboardAdminApi.getCurrentUser()
                ])
                .then(result => {
                    const data = result[0].data
                        .filter(item => item.id !== 1)
                        .map(item => ({ value: item.id, text: item.permission }))

                    this.alterProfilerForm.profile.options = [this.alterProfilerForm.profile.options[0], ...data]
                    this.addUserForm.profile.options = [this.addUserForm.profile.options[0], ...data]
                    this.profile.options = [this.profile.options[0], ...data]

                    if (result[1].data.length) {
                        this.tableData = result[1].data
                    }

                    this.userIdLogged = result[2].data.result[0].id
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        addUserSubmit(event) {
            this.$v.addUserForm.$touch()

            if (this.$v.addUserForm.$anyError) {
                return null
            }

            this.setIsLoading(true)

            const data = {
                name: this.addUserForm.name,
                email: this.addUserForm.email,
                cpf: this.addUserForm.cpf,
                id_status: 1,
                id_permissao: this.addUserForm.profile.selected,
                id_acesso: 1,
                id_user: this.userIdLogged
            }

            platformApi
                .makeRegister(data)
                .then(result => {
                    this.closeSidebarAddUser()
                    this.fetch()
                    this.showModal('success-user-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        openSidebarAddUser() {
            this.$v.addUserForm.$reset()
            this.addUserForm.name = null
            this.addUserForm.email = null
            this.addUserForm.cpf = null
            this.addUserForm.profile.selected = null
        },
        closeSidebarAddUser() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-add-user')
        },
        alterProfile() {
            this.setIsLoading(true)

            usersAdminApi
                .changeProfile(this.userSelected.id, this.alterProfilerForm.profile.selected)
                .then(response => {
                    this.hideModal('alter-profile-modal-ref')
                    this.fetch()
                    this.showModal('success-user-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        openAlterProfileModal(refModalName, data) {
            this.userSelected = data
            this.alterProfilerForm.profile.selected = data.id_permissao
            this.showModal(refModalName)
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        openBlockModal(data) {
            this.userSelected = data
            const blockStatus = this.userSelected.id_status === 1 ? 'bloquear' : 'desbloquear'
            this.message = `Tem certeza que deseja ${blockStatus} o usuário <b>${this.userSelected.name}</b>?`
            this.btnMessage = `Sim, ${blockStatus}`
            this.showModal('block-user-modal-ref')
        },
        setBlockUser() {
            const status = this.userSelected.id_status === 1 ? 2 : this.userSelected.id_status === 2 ? 1 : 2

            this.hideModal('block-user-modal-ref')
            this.setIsLoading(true)

            usersAdminApi
                .setBlockUser(this.userSelected.id, status)
                .then(response => {
                    this.fetch()
                    this.showModal('success-user-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        deleteUser() {
            this.hideModal('delete-user-modal-ref')
            this.setIsLoading(true)

            usersAdminApi
                .deleteUser(this.userSelected.id)
                .then(response => {
                    this.fetch()
                    this.showModal('success-user-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        openDeleteModal(data) {
            this.userSelected = data
            this.message = `Tem certeza que deseja excluir o usuário <b>${this.userSelected.name}</b>?`
            this.showModal('delete-user-modal-ref')
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="./UsersAdminPage-light-theme.css"></style>
<style scope src="./UsersAdminPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/users-admin-page/UsersAdminPage.vue